<template>
  <div class="main-wrap">
    <action-bar title="修改资讯" @back="back" :left="true"></action-bar>
    <ul class="nav">
      <li @click="goto('/home/user')">会员资讯</li>
      <li class="active" @click="goto('/home/password')">修改密码</li>
      <li @click="goto('/home/message')">消息中心</li>
      <li @click="goto('/home/account')">资金明细</li>
    </ul>

    <div class="content">

        <table width="100%">
          <tbody>
            <tr>
              <td>旧密码：</td>
              <td style="width:70% ">
                <input type="password" class="ipt-6" v-model="voldpassword"/>
              </td>
            </tr>
            <tr>
              <td>新密码：</td>
              <td>
                <input type="password" class="ipt-6" v-model="vnewpassword" />
              </td>
            </tr>
            <tr>
              <td>确认密码：</td>
              <td>
                <input type="password" class="ipt-6" v-model="vrenewpassword" />
              </td>
            </tr>
          </tbody>
        </table>
        <div style="text-align:center;margin-top:10px">
          <button type="button" @click="submit" class="btn-bet">确认修改</button>
        </div>

    </div>
  </div>
</template>

<script>
import ActionBar from "@/components/action-bar";
import { password } from "@/service/user";
export default {
  data() {
    return {
        voldpassword:"",
        vnewpassword : "",
        vrenewpassword: ""
    };
  },
  created() {},
  methods: {
       back(){
          this.$router.push('/home/main');
      },
       goto(url){
           this.$router.push(url);
      },
      submit(){
          password({
               old_password:this.voldpassword,
               password :this.vnewpassword,
               password_confirm: this.vrenewpassword  
          }).then(res=>{
              if(res.result == 'ok'){
                  this.$toast.center("密码修复成功");
              }else{
                  this.$toast.center(res.msg);
              }
          })
      }
  },
  components: {
    ActionBar
  }
};
</script>

<style scoped lang="less">
.main-wrap {
  .nav {
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    font-size: 18px;
    li {
      width: 220px;
    }

    .active {
      border-bottom-color: #ba142b;
      border-bottom-width: 4px;
      color: #ba142b;
    }
  }
  .content {
    border-radius: 5px;
    margin: 20px 5px;
    height: auto;
    padding: 5px;
    background-color: #ffffff;
    font-size: 24px;
    table,
    td,
    th {
      height: 50px;
      border: 1px solid #cccccc;
      text-align: center;
      padding-top: 20px;
    }
    th {
      background-color: #eeeeee;
    }

    td .ipt-6 {
        width: 400px !important; 
        height: 50px;
        text-align: left !important;
        border: #999 1px solid;
        
    }

    .btn-bet {
        background: none repeat scroll 0 0 #e92f24;
        border: 1px solid #dc372c;
        border-radius: 4px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        height: 52px;
        text-align: center;
        width: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/password/index.vue